import React from "react";
import { Star, ShieldCheck, BadgeCheck } from "lucide-react";
import { TESTIMONIALS } from "@/data/content";
import { Section, SectionHeading } from "@/components/Primitives";

export default function Testimonials() {
  return (
    <Section className="bg-white" pattern>
      <SectionHeading eyebrow="What Clients Say" title="Trusted by Entrepreneurs Across Borders"
        subtitle="A trusted service provider working with appropriately licensed and regulated partners." center />
      <div className="flex flex-wrap justify-center gap-3 mb-10">
        <span className="inline-flex items-center gap-2 text-sm font-semibold text-navy bg-slate-50 border border-slate-200 rounded-full px-4 py-2"><ShieldCheck size={16} className="text-emerald-brand" /> Trusted service provider</span>
        <span className="inline-flex items-center gap-2 text-sm font-semibold text-navy bg-slate-50 border border-slate-200 rounded-full px-4 py-2"><BadgeCheck size={16} className="text-gold" /> Works with fully authorised partners</span>
        <span className="inline-flex items-center gap-2 text-sm font-semibold text-navy bg-slate-50 border border-slate-200 rounded-full px-4 py-2"><ShieldCheck size={16} className="text-emerald-brand" /> Compliance-first approach</span>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {TESTIMONIALS.map((t) => (
          <div key={t.name} data-testid="testimonial-card" className="rounded-2xl border border-slate-100 bg-slate-50/60 p-6 hover-lift">
            <div className="flex gap-1 mb-3">{[...Array(5)].map((_, i) => <Star key={i} size={16} className="fill-gold text-gold" />)}</div>
            <p className="text-slate-700 text-[15px] leading-relaxed">"{t.text}"</p>
            <div className="mt-5 flex items-center gap-3">
              <div className="w-11 h-11 rounded-full bg-navy text-gold flex items-center justify-center font-bold">{t.name.split(" ").map((n) => n[0]).join("")}</div>
              <div>
                <div className="font-bold text-navy text-sm">{t.name}</div>
                <div className="text-xs text-slate-500">{t.title} · {t.country}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
      <p className="text-center text-xs text-slate-400 mt-8 max-w-2xl mx-auto">Illustrative client feedback shown for demonstration. Names and profiles are representative placeholders.</p>
    </Section>
  );
}
